/**
 * The private switch on the driver app (Warren, 2026-10-22: "Per-charger
 * private switch: same-tenant drivers must pass the pass list too; site host
 * and staff exempt; start path, driver map, pre-start screen").
 *
 * The Api decides; these helpers only read its answer. A private charger
 * this driver may not start arrives as:
 *   - GET /chargers/driver/:id   private_locked: true
 *   - GET /chargers/:id/start-preview   privateLocked: true, and guestAccess
 *     { reason GUEST_ACCESS_DISABLED, detail PRIVATE_CHARGER } (the reason an
 *     older window blocks on)
 *   - POST /chargers/:id/driver-start   403 code PRIVATE_CHARGER
 *   - GET /locations/driver/:id   private_only: true when every stall the
 *     driver could see is private and not theirs
 * The pre-start screen then shows "This is a private charger" instead of a
 * Start button, in the driver's language.
 */

export const PRIVATE_CHARGER = 'PRIVATE_CHARGER' as const;

export interface PrivateChargerRead {
  private_locked?: boolean;
}
export interface PrivatePreviewRead {
  privateLocked?: boolean;
  guestAccess?: { reason?: string; detail?: string } | null;
}

/** Closed to this driver by the private switch, by either read. */
export function isPrivateLocked(
  charger: PrivateChargerRead | null | undefined,
  preview?: PrivatePreviewRead | null,
): boolean {
  if (charger?.private_locked === true) return true;
  if (preview?.privateLocked === true) return true;
  return preview?.guestAccess?.reason === 'GUEST_ACCESS_DISABLED' && preview.guestAccess.detail === PRIVATE_CHARGER;
}

/** driver-start's refusal for the same driver (a window opened before the
 *  switch was turned on). */
export function isPrivateChargerError(err: { code?: string | null } | null | undefined): boolean {
  return err?.code === PRIVATE_CHARGER;
}

/** The station page: every stall this driver could see is private. */
export function isPrivateOnlyStation(location: { private_only?: boolean } | null | undefined): boolean {
  return location?.private_only === true;
}
